export default "__VITE_ASSET__DWlI5b$I__"